import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnChanges, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { ScriptLoaderService } from 'helpers/services/script-loader.service';
import { UserInfo } from 'core/authentication/user-information';
import { AccessHelper } from 'helpers/access.helper';
import { HttpClient } from '@angular/common/http';
import { DisabledHelper } from 'helpers/disabled-helper';

declare let $: any;

@Directive({
  selector: '[permission]'
})
export class PermissionDirective implements OnInit, AfterViewInit {
  @Input() permission: string;

  constructor(private http: HttpClient, private el: ElementRef) {

  }

  ngOnInit (): any {
    this.updateInputStyle();
  }

  ngOnDestroy (): any {

  }

  ngAfterViewInit() {

  }

  updateInputStyle() {
      let flag: boolean = false;

      // Full access permission
      //
      if (AccessHelper.hasAllPermissionFromBaseScope(this.permission)) flag = true;
      else {
        // Specific Read/Modified/Others permission
        //
        if (!AccessHelper.hasModifyingPermission(this.permission)) {
          DisabledHelper.disableInputElement(this.el.nativeElement, 'permission');
        } else {
          DisabledHelper.enableInputElement(this.el.nativeElement, 'permission');
        }

        if (!AccessHelper.hasReadingPermission(this.permission)) {
          $(this.el.nativeElement).css('display', 'none');
        } else {
          $(this.el.nativeElement).css('display', '');
          flag = true;
        }
      }

      if (!flag) $(this.el.nativeElement).css('display', 'none');
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/directives/permission/permission.directive.ts